export default function useCurrency() {
	const format = (e: number) => {
		if (typeof e === 'number') {
			return e.toLocaleString()
		}
	}

	const currencyToNaira = <T = string>(val: string | number, isDiaspora = false) => {
		if (typeof val === 'string' || typeof val === 'number') {
			let amount = val
			// Math.round(val)
			if (!isNaN(amount as number)) {
				amount = Math.round(val as number)
			}

			amount = String(amount)
				.replace(/\D/g, '')
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			const currency = isDiaspora ? '$' : '₦'
			return `${currency}${amount}` as T
		}
		return val as T
	}
	const internationalNoFormat = (labelValue: string | number, prepend = '') => {
		const suffixes = ['M', 'B', 'T', 'Q', 'P', 'E', 'Z', 'Y']
		const num = Math.abs(Number(labelValue))
		// If the number is less than 1,000,000, just return it with commas for thousands.
		if (num < 1.0e6) {
			return `${prepend ?? ''}${num.toLocaleString()}`
		}

		// Find out which label to use by calculating the tier.
		// The tier is a measure of how big the number is in terms of thousands (K), millions (M), billions (B), etc.
		let tier = Math.floor(Math.log10(num) / 3) - 2

		// If the tier is bigger than the labels we have, just use the biggest label.
		if (tier >= suffixes.length) {
			tier = suffixes.length - 1
		}

		// Scale the number down to fit the tier.
		// For example, if the number is 1,500,000 (1.5 million), we scale it to 1.5 for the 'M' label.
		const scaled = num / Math.pow(10, (tier + 2) * 3)

		// Format the scaled number to one decimal place and add the appropriate label. You can also prepend label in case you want to add currency type to it
		return `${prepend || ''}${Number(scaled || 0).toFixed(2) + suffixes[tier || 0]}`
	}
	const StringToNumber = (val: string | number) => {
		const value = typeof val === 'string' ? parseInt(val.replace('₦', '').replace(/,/g, ''), 10) : val
		if (isNaN(value)) {
			return 0
		}
		return value
	}

	return {
		format,
		currencyToNaira,
		StringToNumber,
		internationalNoFormat
	}
}
